<app-dialog [dialogWithInput]="dialog">
    <app-service-container [service]="getProductsService">
        <app-card>
            <div class="row">
                <app-form-field label="Produit" [required]="true">
                    <app-select [parentFormGroup]="formGroup" parentFormControlName="productId" [elements]="productElements"
                        (singleSelectionChanged)="productChanged()"></app-select>
                </app-form-field>
                <app-form-field [required]="true" label="% TVA" sizeLg="2" sizeXl="1">
                    <app-number-input [maxValue]="100" [parentFormGroup]="formGroup" parentFormControlName="taxPercentage"
                                      [decimalDigits]="2" unit="%"></app-number-input>
                </app-form-field>
                <app-form-field [required]="true" label="PU HTVA" sizeLg="2" sizeXl="2">
                    <app-amount-input [parentFormGroup]="formGroup" parentFormControlName="unitPriceVatExcluded"
                                      unit="€ HTVA"></app-amount-input>
                </app-form-field>
                <app-form-field [required]="true" label="PU TTC" sizeLg="2" sizeXl="2">
                    <app-amount-input [parentFormGroup]="formGroup" parentFormControlName="unitPriceVatIncluded"
                                      unit="€ TTC"></app-amount-input>
                </app-form-field>
            </div>
        </app-card>
    </app-service-container>
    <app-button dialog-actions fill="solid" [disabled]="!formGroup.valid" label="Modifier" (clickEvent)="update()" [loading]="updateService.loading$ | async"></app-button>
</app-dialog>